// VNEC v9 — pages/doanh-so.js
// Doanh số / hóa đơn theo HĐ × loại dòng (doanh_thu, hoa_don, dieu_chinh, ...)
import { supabase, getCurrentUser } from '../lib/supabase.js';
import { formatVND } from '../lib/forms.js';

// NOTE: fix import lines — using supabase from correct module
// aliases removed


let _state = { rows: [], user: null, editingMaDS: null };

const LOAI_DONG = [
  { v:'doanh_thu_khac', l:'Doanh thu khác' },
  { v:'doanh_thu_hd',   l:'Doanh thu HĐ' },
  { v:'hoa_don',        l:'Hóa đơn' },
  { v:'dieu_chinh',     l:'Điều chỉnh' }
];

export function renderDoanhSo() {
  window.__pageInit = initDoanhSo;
  return `
    <div class="crud-wrap">
      <div class="page-hd">
        <h2>Doanh số / Hóa đơn</h2>
        <div>
          <button class="btn btn-primary btn-sm" id="ds-new">+ Tạo doanh số</button>
          <button class="btn btn-ghost btn-sm" id="ds-refresh">⟳</button>
        </div>
      </div>
      <div class="crud-filters">
        <input type="text" class="inp" id="f-search" placeholder="Tìm mã DS, mã HĐ gốc, tên dự án…" style="min-width:280px">
        <select class="inp" id="f-year"><option value="">Tất cả năm</option></select>
      </div>
      <div id="ds-table" class="crud-table-wrap"><div class="loading">Đang tải…</div></div>
      <div id="ds-modal" class="modal-overlay" style="display:none"></div>
    </div>`;
}

async function initDoanhSo() {
  _state.user = await getCurrentUser();
  document.getElementById('ds-new').addEventListener('click', () => openForm(null));
  document.getElementById('ds-refresh').addEventListener('click', load);
  document.getElementById('f-search').addEventListener('input', renderTable);
  document.getElementById('f-year').addEventListener('change', renderTable);
  await load();
}

async function load() {
  try {
    const { data, error } = await supabase.from('doanh_so')
      .select('*').is('deleted_at', null).order('created_at', { ascending: false }).limit(2000);
    if (error) throw error;
    const groups = new Map();
    (data || []).forEach(r => {
      const k = r.ma_doanh_so;
      if (!groups.has(k)) {
        groups.set(k, { ma_doanh_so: k, ma_hd_goc: r.ma_hd_goc, ten_du_an: r.ten_du_an,
          nam_tai_chinh: r.nam_tai_chinh, trang_thai: r.trang_thai, created_by: r.created_by,
          created_at: r.created_at, ma_du_an: r.ma_du_an, so_dong: 0, tong_gt: 0, rows: [] });
      }
      const g = groups.get(k);
      g.so_dong++;
      g.tong_gt += parseFloat(r.gia_tri || 0) || 0;
      g.rows.push(r);
    });
    _state.rows = Array.from(groups.values());
    // Populate year filter
    const years = Array.from(new Set(_state.rows.map(r => r.nam_tai_chinh).filter(Boolean))).sort((a,b)=>b-a);
    const yearSel = document.getElementById('f-year');
    const currentVal = yearSel.value;
    yearSel.innerHTML = '<option value="">Tất cả năm</option>' + years.map(y => `<option value="${y}"${currentVal==String(y)?' selected':''}>${y}</option>`).join('');
    renderTable();
  } catch (e) {
    document.getElementById('ds-table').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

function renderTable() {
  const q = (document.getElementById('f-search').value || '').toLowerCase();
  const year = document.getElementById('f-year').value;
  const rows = _state.rows.filter(r =>
    (!year || String(r.nam_tai_chinh) === year) &&
    (!q || (r.ma_doanh_so || '').toLowerCase().includes(q) || (r.ma_hd_goc || '').toLowerCase().includes(q) || (r.ten_du_an || '').toLowerCase().includes(q))
  );
  if (!rows.length) { document.getElementById('ds-table').innerHTML = '<div class="empty">Không có doanh số</div>'; return; }

  let html = '<table class="tbl"><thead><tr><th>Mã DS</th><th>Mã HĐ gốc</th><th>Dự án</th><th class="c">Năm TC</th><th class="c">Dòng</th><th class="r">Tổng GT</th><th class="c">TT</th><th class="c">Thao tác</th></tr></thead><tbody>';
  rows.forEach(r => {
    html += `<tr>
      <td><b>${escH(r.ma_doanh_so)}</b></td>
      <td>${escH(r.ma_hd_goc || '—')}</td>
      <td>${escH(r.ten_du_an || '')}</td>
      <td class="c">${r.nam_tai_chinh || ''}</td>
      <td class="c">${r.so_dong}</td>
      <td class="r money">${formatVND(r.tong_gt)}</td>
      <td class="c">${stBadge(r.trang_thai)}</td>
      <td class="c">
        <button class="btn-mini view" data-act="edit" data-key="${escH(r.ma_doanh_so)}">Sửa</button>
        ${r.trang_thai === 'draft' ? `<button class="btn-mini reject" data-act="delete" data-key="${escH(r.ma_doanh_so)}">Xóa</button>` : ''}
      </td>
    </tr>`;
  });
  html += '</tbody></table>';
  document.getElementById('ds-table').innerHTML = html;

  document.querySelectorAll('#ds-table button[data-act]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.dataset.act === 'edit') openForm(btn.dataset.key);
      else if (btn.dataset.act === 'delete') doDelete(btn.dataset.key);
    });
  });
}

async function openForm(maDS) {
  _state.editingMaDS = maDS;
  const modal = document.getElementById('ds-modal');
  modal.style.display = 'flex';
  let group = maDS ? _state.rows.find(r => r.ma_doanh_so === maDS) : null;
  const duAnList = (await supabase.from('du_an').select('ma_du_an,ten_du_an').eq('trang_thai', 'active')).data || [];

  modal.innerHTML = `
    <div class="modal-box modal-lg">
      <div class="m-hd"><div class="m-title">${maDS ? 'Sửa: ' + escH(maDS) : 'Tạo doanh số mới'}</div><button class="m-close" id="mc">×</button></div>
      <div class="m-body">
        <form id="ds-form">
          <div class="fg">
            <label class="field"><span>Mã HĐ gốc</span><input name="ma_hd_goc" class="inp" value="${escH(group?.ma_hd_goc || '')}"></label>
            <label class="field"><span>Dự án</span><select name="ma_du_an" class="inp"><option value="">—</option>${duAnList.map(d => `<option value="${escH(d.ma_du_an)}"${group?.ma_du_an===d.ma_du_an?' selected':''}>${escH(d.ma_du_an)} — ${escH(d.ten_du_an)}</option>`).join('')}</select></label>
            <label class="field"><span>Tên dự án</span><input name="ten_du_an" class="inp" value="${escH(group?.ten_du_an || '')}"></label>
            <label class="field"><span>Năm tài chính</span><input name="nam_tai_chinh" type="number" class="inp" value="${group?.nam_tai_chinh || new Date().getFullYear()}"></label>
          </div>
          <div class="rows-hd"><h4>Dòng doanh số</h4><button type="button" class="btn btn-ghost btn-sm" id="add-row">+ Thêm dòng</button></div>
          <table class="rows-tbl">
            <thead><tr><th style="width:30px">#</th><th style="width:150px">Loại dòng</th><th>Nội dung</th><th class="r" style="width:140px">Giá trị</th><th style="width:130px">Bắt đầu</th><th style="width:130px">Kết thúc</th><th style="width:30px"></th></tr></thead>
            <tbody id="rows-body"></tbody>
          </table>
          <div class="modal-actions"><button type="button" class="btn btn-ghost" id="cancel">Hủy</button><button type="submit" class="btn btn-primary">Lưu</button></div>
        </form>
      </div>
    </div>`;

  const body = document.getElementById('rows-body');
  const rows = group?.rows || [{}];
  rows.forEach(r => addRowToForm(body, r));
  if (!rows.length) addRowToForm(body, {});

  document.getElementById('mc').addEventListener('click', () => modal.style.display = 'none');
  document.getElementById('cancel').addEventListener('click', () => modal.style.display = 'none');
  document.getElementById('add-row').addEventListener('click', () => addRowToForm(body, {}));
  document.getElementById('ds-form').addEventListener('submit', e => { e.preventDefault(); submitForm(); });
}

function addRowToForm(body, r) {
  const tr = document.createElement('tr');
  const idx = body.children.length + 1;
  tr.innerHTML = `
    <td class="c">${idx}</td>
    <td><select class="inp" name="loai_dong">${LOAI_DONG.map(x => `<option value="${x.v}"${(r.loai_dong||'doanh_thu_khac')===x.v?' selected':''}>${x.l}</option>`).join('')}</select></td>
    <td><input class="inp" name="noi_dung" value="${escH(r.noi_dung || '')}"></td>
    <td><input class="inp r" name="gia_tri" value="${r.gia_tri ? formatVND(r.gia_tri) : ''}"></td>
    <td><input type="date" class="inp" name="bat_dau" value="${r.bat_dau || ''}"></td>
    <td><input type="date" class="inp" name="ket_thuc" value="${r.ket_thuc || ''}"></td>
    <td class="c"><button type="button" class="btn-mini reject" data-act="del">×</button></td>`;
  body.appendChild(tr);
  tr.querySelector('[data-act="del"]').addEventListener('click', () => {
    tr.remove();
    Array.from(body.children).forEach((el,i) => el.children[0].textContent = i+1);
  });
}

async function submitForm() {
  const form = document.getElementById('ds-form');
  const fd = new FormData(form);
  const nam_tai_chinh = parseInt(fd.get('nam_tai_chinh')) || new Date().getFullYear();
  const ma_hd_goc = fd.get('ma_hd_goc') || '';
  const ma_du_an = fd.get('ma_du_an') || null;
  const ten_du_an = fd.get('ten_du_an') || '';

  const body = document.getElementById('rows-body');
  const rows = Array.from(body.children).map((tr, i) => {
    const noi_dung = tr.querySelector('[name="noi_dung"]').value.trim();
    const gia_tri = parseVND(tr.querySelector('[name="gia_tri"]').value);
    if (!noi_dung && !gia_tri) return null;
    return {
      so_thu_tu: (i+1).toString(),
      loai_dong: tr.querySelector('[name="loai_dong"]').value,
      noi_dung,
      gia_tri,
      bat_dau: tr.querySelector('[name="bat_dau"]').value || null,
      ket_thuc: tr.querySelector('[name="ket_thuc"]').value || null
    };
  }).filter(Boolean);

  if (!rows.length) { toast('Thêm ít nhất 1 dòng', 'err'); return; }

  try {
    const maDS = _state.editingMaDS || await genMaDS(nam_tai_chinh);
    if (_state.editingMaDS) {
      const { error: delErr } = await supabase.from('doanh_so').delete().eq('ma_doanh_so', maDS);
      if (delErr) throw delErr;
    }
    const payload = rows.map(r => ({
      ma_doanh_so: maDS, ma_hd_goc, ten_du_an, nam_tai_chinh, ma_du_an,
      so_thu_tu: r.so_thu_tu, loai_dong: r.loai_dong, noi_dung: r.noi_dung, gia_tri: r.gia_tri,
      bat_dau: r.bat_dau, ket_thuc: r.ket_thuc,
      trang_thai: 'draft', 
    }));
    const { error } = await supabase.from('doanh_so').insert(payload);
    if (error) throw error;
    toast(_state.editingMaDS ? 'Đã cập nhật' : 'Đã tạo: ' + maDS, 'ok');
    document.getElementById('ds-modal').style.display = 'none';
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

async function genMaDS(nam) {
  const { data } = await supabase.from('doanh_so').select('ma_doanh_so').like('ma_doanh_so', `DS-${nam}-%`).order('ma_doanh_so', { ascending: false }).limit(1);
  const last = data && data[0] ? parseInt(data[0].ma_doanh_so.split('-')[2]) || 0 : 0;
  return `DS-${nam}-${String(last + 1).padStart(3, '0')}`;
}

async function doDelete(maDS) {
  if (!confirm(`Xóa doanh số ${maDS}?`)) return;
  try {
    const { error } = await supabase.from('doanh_so').update({ deleted_at: new Date().toISOString() }).eq('ma_doanh_so', maDS);
    if (error) throw error;
    toast('Đã xóa', 'ok');
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

function stBadge(st) {
  const map = { Draft:['Nháp','draft'], Pending:['Chờ duyệt','pending'], Approved_L1:['Duyệt L1','l1'], Approved:['Đã duyệt','approved'], Rejected:['Từ chối','rejected'] };
  const [lb, cls] = map[st] || ['—','draft'];
  return `<span class="badge-st badge-${cls}">${lb}</span>`;
}
function escH(s) { return String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
function parseVND(s) { return parseFloat(String(s||'').replace(/[.,\s]/g, '')) || 0; }
function toast(msg, type='ok') {
  const c = document.getElementById('toast-container'); if (!c) { alert(msg); return; }
  const el = document.createElement('div'); el.className = 'toast toast-' + type; el.textContent = msg;
  c.appendChild(el); setTimeout(() => el.remove(), 3500);
}
